import { UserCommentState } from '@amzn/awscat-pattern-library-service-model';

const RESOLVED_COMMENT_STATES: ReadonlySet<string> = new Set([
  UserCommentState.RESOLVED,
  UserCommentState.IMPLEMENTED,
  UserCommentState.IGNORED,
  UserCommentState.DELETED,
]);

/** Whether a comment is in a terminal (resolved) state. */
export function isCommentResolved(state: string): boolean {
  return RESOLVED_COMMENT_STATES.has(state);
}
